import React, {lazy,Component } from 'react'
//import {Switch,Route, Router, withRouter} from 'react-router-dom'
import {Layout } from 'antd';
import {isMobile} from '../components/viewer/ui/constants/index';
import { baseUrlApis } from 'Api/index';
import {store} from 'Store/store.index'
import { inject, observer } from 'mobx-react';

import HeaderLayout from "./HeaderLayout";
import ContentLayout from "./ContentLayout";
import wrapDialog from './wrapperDialog';
import SignUpPopup from '@/components/SignIn/SignUpPopup/SignUpPopup';
const SiderLayout = lazy(()=>import("./SiderLayout"));

@inject('appStore')
@observer
class PageLayout extends Component {
  constructor(props) {
    super(props);
  }
  handleMessage = (event) => {
    let origin = baseUrlApis.getBaseUrl();
    let MESSAGE_KEY = 'message.online.extension'
    let MESSAGE_TO_EXT_KEY = 'message.online.to.extension'
    let message = event.data[MESSAGE_KEY]
    if (`${event.origin}/` === origin && message) {
      //onSignSuccess( event.data[MESSAGE_KEY])
      // console1111.log('TCL: PageLayout ->  -> event.data[message.online]:', event, message)
      if(message.data && message.data.type === 'login-in'){
        store.userStore.loginIn()
        return;
      }
      //clean();
      event.source.postMessage({
        [MESSAGE_TO_EXT_KEY]:{
          data:{
            type:'finish-init',
            msg: message
          }
        }
      }, event.origin)
    }
  }
  componentDidMount() {
    window.addEventListener("message", this.handleMessage, false);
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.handleMessage, false)
  }

  render() {
    const props = this.props;
    const { collaborationModeClassName } = store.appStore
    const { popupSignUpOrSignIn } = store.userStore
    let style = {};//getPageStyleByPathName(props.location.pathname);
    let showSider = false;
    let minWidth = (store.teamsAppStore.inTeamsApp || isMobile()) ? 'auto': 1510;
    return (
      <Layout id={'fo-layout'} className={collaborationModeClassName} style={{minHeight: "100%", minWidth: minWidth}}>
        <HeaderLayout {...props} key={store.accountStore.hasGotUserABRole}></HeaderLayout>
        <Layout /* style={{minHeight:"100%"}} */>
          <Layout style={style}>
          {wrapDialog(
              <ContentLayout {...props}></ContentLayout>
            )}
          </Layout>
          {showSider && wrapDialog(<SiderLayout></SiderLayout>)}
        </Layout>
        {popupSignUpOrSignIn && <SignUpPopup popupSignUpOrSignIn={popupSignUpOrSignIn} srcType={store.userStore.signUpPopupSrcType}></SignUpPopup>}
      </Layout>
    )
  }
}

export default PageLayout;

